
import { Component, Vue } from "vue-property-decorator";

import "primeicons/primeicons.css";

@Component
export default class TheFooter extends Vue {}
